export const NotificationSettingsKeys = {
	all: ["myplann", "notification-settings"] as const,
	settings: () => [...NotificationSettingsKeys.all, "settings"] as const,
};
